<template>
  <div ref="scheduler"></div>
</template>

<script>
import 'dhtmlx-scheduler'
export default {
  name: 'scheduler',
  props: {
    events: {
      type: Array,
      default () {
        return {events: []}
      }
    }
  },
 
  mounted: function () {
    scheduler.skin = "material";
    scheduler.config.header = [
        "month",
        "date",
        "prev",
        "today",
        "next"
    ];
    scheduler.config.dblclick_create = false;
    scheduler.config.drag_create = false;
    scheduler.config.drag_move = false;

    let _this = this
    scheduler.templates.event_bar_text = function(start,end,event){
      return _this.$i18n.t(event.text);
    };

    scheduler.templates.tooltip_text = function(start,end,ev){
        return "<b>Project:</b> "+ev.text+"<br/><b>Task:</b> " + 
        ev.text
    };

    scheduler.attachEvent("onDblClick", function(){ return false });
 
    scheduler.init(this.$refs.scheduler, new Date, "month");
    scheduler.parse(this.$props.events);
  },
  methods:{
    closeScheduler(){
      scheduler.clearAll();
    }
  }
}
</script>
 
<style>
    @import "~dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css";
</style>